'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dDirective$002dDescription$0024$0024anon$002461 from "./presto.types$-Directive-Description$$anon$61.js";
import * as $j_presto$002etypes$0024$002dDirective$002dDescription$0024$0024anon$002462 from "./presto.types$-Directive-Description$$anon$62.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DirectiveDescription$() {
  this.c5h = null;
  this.c5i = false;
  this.c5f = null;
  this.c5g = false;
  this.c5l = null;
  this.c5m = false;
  this.c5j = null;
  this.c5k = false;
  this.c5n = null;
  this.c5o = false;
}
export { $c_Lpresto_types$DirectiveDescription$ as $c_Lpresto_types$DirectiveDescription$ };
$p = $c_Lpresto_types$DirectiveDescription$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DirectiveDescription$;
/** @constructor */
function $h_Lpresto_types$DirectiveDescription$() {
}
export { $h_Lpresto_types$DirectiveDescription$ as $h_Lpresto_types$DirectiveDescription$ };
$h_Lpresto_types$DirectiveDescription$.prototype = $p;
$p.cI3 = (function() {
  if ((!this.c5i)) {
    this.c5h = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c5i = true;
  }
  return this.c5h;
});
$p.v1 = (function() {
  if ((!this.c5g)) {
    this.c5f = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.c5g = true;
  }
  return this.c5f;
});
$p.cIN = (function() {
  if ((!this.c5m)) {
    this.c5l = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c5m = true;
  }
  return this.c5l;
});
$p.cIA = (function() {
  if ((!this.c5k)) {
    this.c5j = new $j_presto$002etypes$0024$002dDirective$002dDescription$0024$0024anon$002461.$c_Lpresto_types$DirectiveDescription$$anon$61(this);
    this.c5k = true;
  }
  return this.c5j;
});
$p.cJ4 = (function() {
  if ((!this.c5o)) {
    this.c5n = new $j_presto$002etypes$0024$002dDirective$002dDescription$0024$0024anon$002462.$c_Lpresto_types$DirectiveDescription$$anon$62(this);
    this.c5o = true;
  }
  return this.c5n;
});
var $d_Lpresto_types$DirectiveDescription$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DirectiveDescription$, "presto.types$DirectiveDescription$", ({
  Zs: 1,
  D: 1
}));
export { $d_Lpresto_types$DirectiveDescription$ as $d_Lpresto_types$DirectiveDescription$ };
var $n_Lpresto_types$DirectiveDescription$;
function $m_Lpresto_types$DirectiveDescription$() {
  if ((!$n_Lpresto_types$DirectiveDescription$)) {
    $n_Lpresto_types$DirectiveDescription$ = new $c_Lpresto_types$DirectiveDescription$();
  }
  return $n_Lpresto_types$DirectiveDescription$;
}
export { $m_Lpresto_types$DirectiveDescription$ as $m_Lpresto_types$DirectiveDescription$ };
//# sourceMappingURL=presto.types$-Directive-Description$.js.map
